import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-export_history",
  "use": "icon-export_history-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-export_history\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M16.4,7.33H7.6L7,8.67h10.1ZM12,10.67l2.6,2.66H12.65V16h-1.3V13.33H9.4ZM17.2,10H6.8v6.67H17.2Zm0-4,1.3,2.67v8.66a.66.66,0,0,1-.65.67H6.15a.66.66,0,0,1-.65-.67V8.67L6.8,6Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol